import { render } from "./FeaturesPage.vue?vue&type=template&id=cd963fa6"
import script from "./FeaturesPage.vue?vue&type=script&lang=js"
export * from "./FeaturesPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__